import React, { ReactNode } from 'react';
import styled from 'styled-components';
import {
  BorderProps,
  BoxShadowProps,
  FlexboxProps,
  LayoutProps,
  PaddingProps,
  PositionProps,
  TextAlignProps,
  space,
} from 'styled-system';

import Box from 'components/Box';
import { breakpoints, colors, shadows, transition } from 'theme';
import { isDefined } from 'utils/functional';

export const SmallTile = styled(({ blueBorder, ...props }) => (
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Box {...props} />
))`
  position: relative;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 10px;
  box-shadow: ${shadows.low};
  word-wrap: break-word;
  ${(props) => (props.bg ? '' : 'background: white')};
  ${(props) =>
    isDefined(props.p)
      ? ''
      : `
  padding: 20px;
  @media (min-width: ${breakpoints[1]}) {
    padding: 30px;
  }
  `}
  ${space};
  ${(props) =>
    props.blueBorder &&
    `
    position: relative;
    overflow: hidden;
    &::before {
      content: '';
      position: absolute;
      bottom: 100%;
      left: 0;
      transform: translateY(5px);
      width: 100%;
      height: 100%;
      background: ${colors.waterBlue};
      transition: all ${transition};
    }
  `}
`;
export const TileHeader = styled(
  ({
    isActive,
    hasError,
    children,
    ...props
  }: {
    isActive?: boolean;
    hasError?: boolean;
    children?: ReactNode;
  }) => (
    <Box
      position="relative"
      width="100%"
      borderRadius="12px 12px 0 0"
      overflow="hidden"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      <Box py={[16, null, null, 32]} px={[20, null, null, 40]}>
        {children}
      </Box>
    </Box>
  )
)`
  -webkit-mask-image: -webkit-radial-gradient(white, black);
  &::before {
    content: '';
    position: absolute;
    bottom: 100%;
    left: 0;
    transform: translateY(5px);
    width: 100%;
    height: 100%;
    background: ${colors.waterBlue};
    transition: all ${transition};
  }
  ${(props) =>
    props.hasError &&
    `
    &::before {
      background: ${colors.scarlet};
    }
  `}
  ${(props) =>
    props.isActive &&
    `
    color: white;
    &::before {
      transform: translateY(100%);
    }
  `}
`;
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition, @typescript-eslint/no-explicit-any
export const TileBody = (props?: Record<string, any>) => (
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Box p={[20, null, null, 40]} borderRadius="0 0 12px 12px" {...props} />
);

const Tile = styled(
  ({
    children,
    blueBorder,
    ...props
  }: {
    children: ReactNode;
    blueBorder?: boolean;
    className?: string;
  }) => (
    <Box
      borderRadius="12px"
      boxShadow="0 2px 4px rgba(0, 0, 0, 0.1)"
      bg="white"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      {children}
    </Box>
  )
)<
  PaddingProps &
    BoxShadowProps &
    PositionProps &
    LayoutProps &
    FlexboxProps &
    TextAlignProps &
    BorderProps
>`
  ${(props) =>
    props.blueBorder &&
    `
    position: relative;
    overflow: hidden;
    &::before {
      content: '';
      position: absolute;
      bottom: 100%;
      left: 0;
      transform: translateY(5px);
      width: 100%;
      height: 100%;
      background: ${colors.waterBlue};
      transition: all ${transition};
    }
  `}
`;
export default Tile;
